import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const businessStory = gql`
  query getBusinessStory($businessId: ID!) {
    businessStory(businessId: $businessId) {
      persona {
        diva {
          redemptions
          uniqueDeals
          totalSavingsGbp
          totalSavingsAud
        }
        enthusiast
        guru {
          engagementRate
        }
        saver {
          totalSavingsGbp
          totalSavingsAud
        }
        rockstar {
          engagementRate
          totalSavingsGbp
          totalSavingsAud
        }
      }
      highlights {
        engagement {
          engagedUsers
        }
        savings {
          totalSavingsGbp
          totalSavingsAud
          coffees
        }
      }
      cards {
        total {
          redemptions
          uniqueDeals
          totalSavingsGbp
          totalSavingsAud
        }
        deal {
          type
          dealId
          redemptions
          totalSavingsGbp
          totalSavingsAud
        }
      }
    }
  }
`

export const businessStoryKey = getQueryNames(businessStory)[0]

export default businessStory
